import { useMutation, useQueryClient } from '@tanstack/react-query'
import { CommentsHttpClient } from '@omnea-app/comments/commentsHttpClient'
import { useAuthenticatedUser } from '@omnea-app/fe-auth/UserSessionProvider'
import { throwIfApiError } from '@omnea-app/legacy/utils/error-handling/throwifApiError'
import { requestCommentsQueryKey } from './useGetRequestComment'

interface ResolveAmendmentRequestInput {
  commentIds: string[]
  requestFormId: string
}

export const useResolveAmendments = ({ requestId }: { requestId: string }) => {
  const { getToken } = useAuthenticatedUser()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (body: ResolveAmendmentRequestInput) => {
      const apiClient = new CommentsHttpClient({ authorization: await getToken() })
      const { data, error } = await apiClient.POST('/resolve-amendment-request', {
        body,
      })
      throwIfApiError(error)
      return data
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [requestCommentsQueryKey, requestId] })
    },
  })
}
